import { UserFacingError } from './errors'

export class BookingNotFoundError extends UserFacingError {
  constructor() {
    super('The booking you are looking for no longer exists.')
    this.name = 'BookingNotFoundError'
  }
}

export class BookingCustomerNotFoundError extends UserFacingError {
  constructor() {
    super('Customer not found')
    this.name = 'BookingCustomerNotFoundError'
  }
}

export class BookingConflictError extends UserFacingError {
  constructor(message?: string) {
    super(message ?? 'A scheduling conflict was detected.')
    this.name = 'BookingConflictError'
  }
}

export class HostedHuntRuleError extends UserFacingError {
  constructor(message?: string) {
    super(message ?? 'This hosted hunt cannot accept that change.')
    this.name = 'HostedHuntRuleError'
  }
}

export class InvoiceNotFoundError extends UserFacingError {
  constructor() {
    super('The invoice you are looking for no longer exists.')
    this.name = 'InvoiceNotFoundError'
  }
}

export class BookingHasOpenInvoicesError extends UserFacingError {
  constructor() {
    super('Cannot delete a booking with an active invoice. Void the invoice first, then delete the booking.')
    this.name = 'BookingHasOpenInvoicesError'
  }
}
